import { Injectable } from "@angular/core";
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "../../config/config";
import { map } from 'rxjs/operators';
import { commonFunctionService } from "../utils/commonFunctions";
import { apiConstants } from "../constant/apiConstant";

@Injectable()
export class GroupService {

  private _url = AppSettings.API_ENDPOINT;
  private baseURLVersion3 = AppSettings.API_ENDPOINT_V3;
  private countryName = 'stringFile/countryCode.json';
  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem("usertoken")||"";
    return new HttpHeaders({
      token: token,
    });
  }

  constructor(private http: HttpClient,private commonFunction: commonFunctionService) {
  }

  //import student proceed [validate json data for duplicates with temp table]
  validateJsonDataOnProceed(data, getSchoolId, getImportStudentsClassId, getAcademicId, AUTHTOKEN) {
    let params = data;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/importStudent?schoolId=' + getSchoolId + '&classId=' + getImportStudentsClassId + '&academicId=' + getAcademicId,
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getCountryName(){
    return this.http.get(this.countryName).pipe(map(res => res));
  }

  //update student details
  updateStudentDetails(admissionObj, AUTHTOKEN) {
    let params = admissionObj;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/addstudent/updateStudent',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  //fetch available class categories
  groupsClassCategories(schoolId, AUTHTOKEN) {
    let params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classCategory',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //fetch available class with cat id
  groupsAvailableClass(schoolId, catid, AUTHTOKEN) {
    let params = { schoolId: schoolId, categoryId: catid };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/className',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //fetch available classes in school with school id
  groupsAvailableAllClass(schoolId, AUTHTOKEN) {
    let params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/allClassName',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //fetch available class section with class id
  groupsAvailableClassSection(classid, AUTHTOKEN) {
    let params = { classId: classid };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classSectionName',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getLastRegId(AUTHTOKEN) {
    let params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/addstudent/getLastRegId',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get student list
  groupsStudentList(schoolId, academicId, catId, classId, sectionId, countfrom, lengthOf, AUTHTOKEN) {
    let params = {
      schoolId: schoolId,
      academicId: academicId,
      categoryId: catId,
      classId: classId,
      sectionId: sectionId,
      countFrom: countfrom,
      lengthOf: lengthOf
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get academic list
  groupsStudentAcademicList(schoolId, AUTHTOKEN) {
    let params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/academiclist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get school designation list
  groupsSchoolDesignationList(schoolId, AUTHTOKEN) {
    let params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolDesignation',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get staff list
  groupsStaffList(schoolId, designationId, isBlockedStatus, AUTHTOKEN) {
    let params = { schoolId: schoolId, designationId: designationId, isBlockedStatus: isBlockedStatus };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get staff list details
  groupsStaffListDetail(staffId, AUTHTOKEN) {
    let params = { staffId: staffId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffDetail',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get staff qualification list
  groupsStaffQualifList(schoolId, AUTHTOKEN) {
    let params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffQualification',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //staff update
  groupsStaffUpdate(staffName, staffDOB, staffGender, staffAppStatus, staffBlockStatus, staffQualification, staffDesignation, employement, staffDOJ, staffMobile, staffMobileCode, staffEmail, staffAddress, staffId, reason, aadharNumber, AUTHTOKEN) {
    let params = {
      staffName: staffName,
      staffDOB: staffDOB,
      staffGender: staffGender,
      staffAppStatus: staffAppStatus,
      staffBlockStatus: staffBlockStatus,
      staffQualification: staffQualification,
      staffDesignation: staffDesignation,
      employement: employement,
      staffDOJ: staffDOJ,
      staffMobile: staffMobile,
      staffMobileCode: staffMobileCode,
      staffEmail: staffEmail,
      staffAddress: staffAddress,
      staffId: staffId,
      reason: reason,
      aadharNumber: aadharNumber
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffUpdate',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  //staff update
  groupsAddNewStaff(staffName, empId, dateOfBirth, gender, isAppUser, isBlocked, qualification, qualificationId, designationId, dateOfJoining, mobileNumber, countryCode, emailId, address, aadharNumber, schoolId, AUTHTOKEN) {
    let params = {
      staffName: staffName,
      empId: empId,
      dateOfBirth: dateOfBirth,
      gender: gender,
      isAppUser: isAppUser,
      isBlocked: isBlocked,
      qualification: qualification,
      qualificationId: qualificationId,
      designationId: designationId,
      dateOfJoining: dateOfJoining,
      mobileNumber: mobileNumber,
      countryCode: countryCode,
      emailId: emailId,
      address: address,
      schoolId: schoolId,
      aadharNumber: aadharNumber
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffAdd',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  //addnewdesignation
  groupsStaffEditDesignation(designationId, designationName, isSuperAdmin, isFeeDefaulterAdmin, isFinanceAdmin, isClassTeacher, isDriver, AUTHTOKEN) {
    let params = {
      designationId: designationId,
      designationName: designationName,
      isSuperAdmin: isSuperAdmin,
      isFinanceAdmin: isFinanceAdmin,
      isFeeDefaulterAdmin: isFeeDefaulterAdmin,
      isClassTeacher: isClassTeacher,
      isDriver: isDriver
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffEditDesignation',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //add new qualification
  groupsStaffEditQualification(pkStaffQualificationId, qualification, AUTHTOKEN) {
    let params = { pkStaffQualificationId: pkStaffQualificationId, qualification: qualification };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffEditQualification',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //addnewdesignation
  groupsStaffAdddesignation(schoolId, designation, isSuperAdmin, isFeeDefaulterAdmin, isFinanceAdmin, isClassTeacher, isDriver, AUTHTOKEN) {
    let params = {
      schoolId: schoolId,
      designation: designation,
      isSuperAdmin: isSuperAdmin === undefined ? 0 : isSuperAdmin,
      isFinanceAdmin: isFinanceAdmin === undefined ? 0 : isFinanceAdmin,
      isFeeDefaulterAdmin: isFeeDefaulterAdmin === undefined ? 0 : isFeeDefaulterAdmin,
      isClassTeacher: isClassTeacher === undefined ? 0 : isClassTeacher,
      isDriver: isDriver === undefined ? 0 : isDriver,
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffAddDesignation',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //add new qualification
  groupsStaffAddqualification(schoolId, qualification, AUTHTOKEN) {
    let params = { schoolId: schoolId, qualification: qualification };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/staffAddQualification',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  //view student detail from list selection
  getSelectedStudentDetail(studentId, AUTHTOKEN) {
    let params = { studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentview',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //get class detail with classid
  getClassDetailWithClassId(classId, AUTHTOKEN) {
    let params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentclassdetail',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  //add student
  addNewStudentDetails(studentName, studentDOB, studentGender, studentClassId, studentAdmissionDate, studentAdmissionNumber, studentParentName, studentParentContact, studentParentEmail, studentAddress, studentAcademicId, studentSchoolId, AUTHTOKEN) {

    let params = {
      studentName: studentName,
      studentDOB: studentDOB,
      studentGender: studentGender,
      studentClassId: studentClassId,
      studentAdmissionDate: studentAdmissionDate,
      studentAdmissionNumber: studentAdmissionNumber,
      studentParentName: studentParentName,
      studentParentContact: studentParentContact,
      studentParentEmail: studentParentEmail,
      studentAddress: studentAddress,
      studentAcademicId: studentAcademicId,
      studentSchoolId: studentSchoolId
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/addstudent',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  //student bulk upload xls-json to temp
  createxlsjson(postData, file) {
    return this.http.post(this._url + '/uploadxlsjson', postData, file)
      .pipe(map(res => res));
  }

  fetchingFeesDetailForUpdate(classId, studentId, AUTHTOKEN) {
    let params = { classId: classId, studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/checkingForUpdateStudent',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  searchStudent(searchCriteria, AUTHTOKEN) {
    let params = searchCriteria;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/searchstudents',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  searchStaff(searchCriteria, AUTHTOKEN) {
    let params = searchCriteria;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/searchstaffs',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  updateStudentRollNumbersToAlphabetOrder(classId, AUTHTOKEN) {
    let params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/class_management/classmanagement/updatestudentrollnumberswithalphabet',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getStudentDetailsForEditForm(studentId, AUTHTOKEN) {
    let params = { studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentviewv2',
      params, { headers: headers })
      .pipe(map(res => res));
  }


  getClassStandardsByCategoryV2(categoryId, AUTHTOKEN) {
    let params = { categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/getClassStandardsByCategoryV2',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassSectionsByClassIdFunV2(classStandardId, AUTHTOKEN) {
    let params = { classStandardId: classStandardId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/getClassSectionsByClassIdFunV2',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  studentClassChangeValidation(newClassId, oldClassId, studentId, AUTHTOKEN) {
    let params = { newClassId: newClassId, oldClassId: oldClassId, studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentClassChangeValidation',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  upload(schoolId, classId, formData) {

    return this.http.post<any>(this._url + '/uploadxlsjson?schoolId=' + schoolId + '&classId=' + classId,
      formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {

      switch (event.type) {

        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };

        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }

  fetchStudentUpdateHistory(params) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', localStorage.getItem('usertoken'));
    return this.http.post(this._url + '/studentlist/getStudentUpdateHistory',
      params, { headers: headers }).pipe(map(res => res));
  }
  //fetch school houses
  getSchoolHouseList(authToken) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.get(this._url + '/studentlist/schoolhouselist', { headers: headers }).pipe(map(res => res));
  }

  removeStaffProfilePic(AUTHTOKEN, staffId) {
    let params = { staffId: staffId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.put(this._url + '/stafflist/removeStaffProfilePic',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getDocumentType() {
    const headers = this.commonFunction.appendHeader(); 
    const schoolInfo  = localStorage.getItem('schoolAllInfo');
    const parsedSchoolInfo = JSON.parse(schoolInfo);
    const lang= 'en';
    return this.http.get(this.baseURLVersion3 + `${apiConstants.getDocumentHubDocumentType}/?lang=en&academicId=${parsedSchoolInfo.currentAcademicId}`, { headers }).pipe(map(res => res));
  }

  uploadDocumentForDocumentHub(body, media){
    const form = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty(key)) {        
          form.append(key, body[key]);        
      }
    }
      let mediaObj = media;      
      form.append("studentMedia",mediaObj, mediaObj.name);

    const headers = this.getHeaders()
    return this.http.post(this.baseURLVersion3 + apiConstants.uploadDocumentInDocumentHub ,form, { headers }).pipe(map(res => res));

  }


  getUploadedDocumentInfo (studentId,academic){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.baseURLVersion3 + `${apiConstants.getUploadedDocumentData}/?lang=en&academicId=${academic}&studentId=${studentId}`, { headers }).pipe(map(res => res));
  }
  
  deleteUploadedDoc(body){
    const headers = this.commonFunction.appendHeader();
    return this.http.delete(this.baseURLVersion3 + apiConstants.deleteUploadedDoc , { body,headers }).pipe(map(res => res));
  }

  //get student list for a class/section to update roll numbers
  getClassStudentListForRollNumber(classId, lang = 'en') {
    const headers = this.commonFunction.appendHeader();
    return this.http.get(this.baseURLVersion3 + `${apiConstants.getClassStudentListForRollNumber}?classId=${classId}&lang=${lang}`, { headers })
      .pipe(map(res => res));
  }

  //bulk update roll numbers for students in a class/section
  bulkUpdateStudentRollNumber(classId, studentList, lang = 'en') {
    const headers = this.commonFunction.appendHeader();
    const body = { lang: lang, classId: classId, studentList: studentList };
    return this.http.post(this.baseURLVersion3 + apiConstants.bulkUpdateStudentRollNumber, body, { headers })
      .pipe(map(res => res));
  }

  exportStaffList(designationId: number[] | null, appStatus: number | null) {
    const token = localStorage.getItem('usertoken') || '';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'Authorization': 'Bearer ' + token
    });
    const body = { designationId, appStatus };
    return this.http.post(this.baseURLVersion3 + '/stafflist/export', body, {
      headers,
      responseType: 'blob'
    });
  }

}
